import { render, staticRenderFns } from "./StartKit.vue?vue&type=template&id=36fcf161&lang=pug&"
import script from "./StartKit.vue?vue&type=script&lang=js&"
export * from "./StartKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports